exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mouseOverContent {\n  position: absolute;\n  width: 270px;\n  background: #bdd4f9;\n  padding: 3px;\n  pointer-events: none;\n  text-align: center;\n  font: 14px sans-serif;\n  height: 50px;\n  border-radius: 4px;\n  border: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/jvutukur/Downloads/HeatMap/ng-heatmap/ng-heatmap/src/app/components/heat-map/heat-map.component.scss
// module id = ../../../../../src/app/components/heat-map/heat-map.component.scss
// module chunks = main